import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
    faCrown, faMedal, faShield, faHexagon, faGem, faStar, faFeather,
    faWandMagicSparkles, faFire, faSnowflake, faMountain, faTrophy, faRibbon,
    faDiamond, faBolt, faVial, faLeaf, faMoon, faSun, faEgg, faHourglassEnd,
    faDice, faWind, faCloud, faHouse, faLifeRing, faTornado, faPenFancy,
    faDrum, faGuitar, faLightbulb, faKey, faLock, faAnchor, faSailboat,
    faCode, faFlask, faPalette, faClover, faBridge, faChess,
    faLandmark
} from '@fortawesome/free-solid-svg-icons';

// Map badge names to Font Awesome icons
const BADGE_ICON_MAP: Record<string, any> = {
    'crown': faCrown,
    'medal': faMedal,
    'shield': faShield,
    'hexagon': faHexagon,
    'clover': faClover,
    'gem': faGem,
    'star': faStar,
    'feather': faFeather,
    'wand-magic-sparkles': faWandMagicSparkles,
    'fire': faFire,
    'snowflake': faSnowflake,
    'mountain': faMountain,
    'trophy': faTrophy,
    'ribbon': faRibbon,
    'diamond': faDiamond,
    'bolt': faBolt,
    'vial': faVial,
    'leaf': faLeaf,
    'moon': faMoon,
    'sun': faSun,
    'egg': faEgg,
    'hourglass-end': faHourglassEnd,
    'dice': faDice,
    'wind': faWind,
    'tornado': faTornado,
    'cloud': faCloud,
    'house': faHouse,
    'bridge': faBridge,
    'drum': faDrum,
    'guitar': faGuitar,
    'lightbulb': faLightbulb,
    'key': faKey,
    'lock': faLock,
    'anchor': faAnchor,
    'sailboat': faSailboat,
    'code': faCode,
    'flask': faFlask,
    'palette': faPalette,
    'pen-fancy': faPenFancy,
    'chess': faChess,
    'landmark': faLandmark,
    'lifering': faLifeRing,
};

interface TeamBadgeProps {
    badge?: string;
    color?: string;
    size?: 'sm' | 'md' | 'lg';
    style?: React.CSSProperties;
}

export const TeamBadge: React.FC<TeamBadgeProps> = ({
    badge,
    color = 'var(--accent-team-color)',
    size = 'md',
    style
}) => {
    if (!badge) return null;

    const icon = BADGE_ICON_MAP[badge];
    if (!icon) return null;

    const sizeMap = {
        'sm': '0.8em',
        'md': '1em',
        'lg': '1.2em',
    };

    return (
        <FontAwesomeIcon
            icon={icon}
            style={{
                color,
                marginRight: '6px',
                fontSize: sizeMap[size],
                ...style
            }}
            title={`Team badge: ${badge}`}
        />
    );
};
